import { firebaseAuth, firebaseAnalytics } from '../firebase';

export function initializeAnalytics() {
  firebaseAuth.onAuthStateChanged((user) => {
    if (user) firebaseAnalytics.setUserId(user.uid);
  });
}
